import { Button, Form, Input, Modal, message } from "antd";
import { useEffect } from "react";

const layout = {
  labelCol: { span: 8 },
  wrapperCol: { span: 16 },
};

export const UpdateStoreModal = ({ open, onCancel, onSubmit, initialValues }) => {
  const [form] = Form.useForm();

  useEffect(() => {
    if (open) {
      form.setFieldsValue(initialValues);
    }
  }, [open, form, initialValues]);

  const handleSubmit = async () => {
    try {
      const values = await form.validateFields();
      onSubmit(values);
    } catch (error) {
      message.error("Por favor, preencha todos os campos obrigatórios");
    }
  };

  const formatCNPJ = (value) => {
    if (!value) return value;
    
    const cleaned = value.replace(/\D/g, '');
    const match = cleaned.match(/^(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})$/);
    
    if (match) {
      return `${match[1]}.${match[2]}.${match[3]}/${match[4]}-${match[5]}`;
    }
    return cleaned;
  };

  return (
    <Modal
      open={open}
      title="Editar Informações da Concessionária"
      onCancel={onCancel}
      onOk={handleSubmit}
      footer={[
        <Button key="back" onClick={onCancel}>
          Cancelar
        </Button>,
        <Button key="submit" type="primary" onClick={handleSubmit}>
          Salvar
        </Button>,
      ]}
    >
      <Form {...layout} form={form}>
        <Form.Item
          label="Nome"
          name="title"
          rules={[{ required: true, message: 'Campo obrigatório' }]}
        >
          <Input placeholder="Nome da concessionária" />
        </Form.Item>

        <Form.Item
          label="CNPJ"
          name="cnpj"
          rules={[
            { required: true, message: 'Campo obrigatório' },
            {
              pattern: /^\d{2}\.\d{3}\.\d{3}\/\d{4}-\d{2}$/,
              message: 'CNPJ inválido',
            },
          ]}
        >
          <Input
            placeholder="00.000.000/0000-00"
            onChange={(e) => {
              const formatted = formatCNPJ(e.target.value);
              form.setFieldsValue({ cnpj: formatted });
            }}
          />
        </Form.Item>
      </Form>
    </Modal>
  );
}; 